export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_281.28a090b4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};